import { Button } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import QuestionModel from "../Models/Survey/Questions/QuestionModel";
import SurveyService from "../Services/SurveyService";

export default function YesNoAnswers(props: {
  questionModel: QuestionModel;
  surveyId: string;
  setQuestionModel: Function;
  setIsFirstQuestion: Function;
  setCurrentQuestionId: Function;
  setLoading: Function;
}) {
  const { t, i18n } = useTranslation("survey");

  const surveyService = useMemo(() => new SurveyService(), []);
  const hasPossibleAnswer = props.questionModel.possibleAnswers.length > 0;
  console.log(hasPossibleAnswer);
  console.log(props.questionModel.possibleAnswers);
  if (props.questionModel !== undefined) {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ justifyContent: "center" }}>
            <Button
              className="m-2"
              variant="outlined"
              style={{
                textTransform: "none",
                maxWidth: "100%",
              }}
              onClick={() =>
                clickAnswer(
                  hasPossibleAnswer
                    ? props.questionModel.possibleAnswers[0].answer
                    : "Ja",
                  hasPossibleAnswer
                    ? props.questionModel.possibleAnswers[0].nextQuestionId
                    : null,
                  hasPossibleAnswer
                    ? props.questionModel.possibleAnswers[0].id
                    : null,
                )
              }
            >
              {hasPossibleAnswer
                ? (props.questionModel.possibleAnswers[0].translatedAnswer ??
                  props.questionModel.possibleAnswers[0].answer)
                : t("Ja")}
            </Button>

            <Button
              className="m-2"
              variant="outlined"
              style={{
                textTransform: "none",
                maxWidth: "100%",
              }}
              onClick={() =>
                clickAnswer(
                  hasPossibleAnswer
                    ? props.questionModel.possibleAnswers[1].answer
                    : "Nee",
                  hasPossibleAnswer
                    ? props.questionModel.possibleAnswers[1].nextQuestionId
                    : null,
                  hasPossibleAnswer
                    ? props.questionModel.possibleAnswers[1].id
                    : null,
                )
              }
            >
              {hasPossibleAnswer
                ? (props.questionModel.possibleAnswers[1].translatedAnswer ??
                  props.questionModel.possibleAnswers[1].answer)
                : t("Nee")}
            </Button>
          </div>

          {props.questionModel.imageBase64String && (
            <img
              src={`data:${props.questionModel.imageType};base64,${props.questionModel.imageBase64String}`}
              alt="Vraag afbeelding"
              style={{
                marginTop: "1rem",
                width: "auto",
                height: "350px",
                display: "block",
              }}
            />
          )}
        </div>
      </>
    );
  }

  return <></>;

  function clickAnswer(
    answer: string,
    nextQuestionId: string | null,
    possibleAnswerId: string | null,
  ) {
    if (props.questionModel) {
      props.setLoading(true);

      surveyService
        .saveAnswer(
          {
            surveyId: props.surveyId,
            questionId: props.questionModel.id,
            answer: answer,
            nextQuestionId: nextQuestionId,
            possibleAnswerId: possibleAnswerId,
          },
          i18n.language,
        )
        .then((result) => {
          if (result) {
            if (result.success) {
              //do stuff with question
              if (result.nextQuestionModel !== null) {
                //set Progress bar
                props.setQuestionModel(result.nextQuestionModel);
                props.setIsFirstQuestion(
                  result.nextQuestionModel.thisIsTheFirstQuestion,
                );
                props.setCurrentQuestionId(result.nextQuestionModel.id);
              }
            } else {
              toast.error(t("Fout bij opslaan van vraag."));
            }
          }
          props.setLoading(false);
        });
    }
  }
}
